import { render } from "./Viewer3D.vue?vue&type=template&id=49bad516&scoped=true&ts=true"
import script from "./Viewer3D.vue?vue&type=script&lang=ts"
export * from "./Viewer3D.vue?vue&type=script&lang=ts"

import "./Viewer3D.vue?vue&type=style&index=0&id=49bad516&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49bad516"]])

export default __exports__